import { ApiParameters } from "./api-parameters";
import { ApiPostRequest } from "./api-post-request";

export class UnsubscribeNewsletterRequest extends ApiPostRequest
{
    public constructor(email: string, webapiBasepath: string)
    {
        super(  'newsletter/unsubscribe', 
                new ApiParameters, 
                null, 
                {
                    'Email':email
                },
                webapiBasepath   
            );
    }
}